import { render, staticRenderFns } from "./Face2Face.vue?vue&type=template&id=4dadffcc&scoped=true&"
import script from "./Face2Face.vue?vue&type=script&lang=js&"
export * from "./Face2Face.vue?vue&type=script&lang=js&"
import style0 from "./Face2Face.vue?vue&type=style&index=0&id=4dadffcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dadffcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VSpeedDial})
